export default "__VITE_ASSET__CwpVzL6z__"